<div id="c_sitemdetail_card_body">
    <ul id="c_sitem_detail_override_card_body">
        <li class="c-sitem-detail-header-row breadcrumb-font" id="c_sitem_breadcrumbs">
            <span *ngIf="showOutage" style="color: #0079EF; cursor: pointer;"
                [routerLink]='["/outages"]'>{{ 'OutagesList.outages' | translate }} </span>
            <span *ngIf="!showOutage" style="color: #0079EF; cursor: pointer;"
                [routerLink]='["/services"]'>{{ 'ServiceItemDetail.items' | translate }}</span>
            <em class="fa fa-angle-right fa-lg px-1"></em>
            <span> {{ 'ServiceItemDetail.details' | translate}}</span>
        </li>
    </ul>

    <!-- Row for Service Item Image, Service Item Name, Service Items create requests Icons ( I, R, C )-->
    <div class="row" id="c_sitem_name_description_row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="row">
                <!-- Service Item Image-->
                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-2 mt-1">
                    <img id="zsd_sitem_detail_image" class="m-auto" *ngIf="serviceItemDetail.iconData"
                        [src]="_DomSanitizer.bypassSecurityTrustUrl('data:' + serviceItemDetail.iconMime + ';base64, ' + serviceItemDetail.iconData)">
                </div>

                <!-- Service Item Name-->
                <div class="col-xl-8 col-lg-8 col-md-7 col-sm-11 col-10">
                    <div id="sd_sitem_name" class="detail-title-font">
                        {{serviceItemDetail.itemBasicInfo?.itemName}}
                    </div>
                </div>

                <!-- Service Item Request Creation -->
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 mt-3">
                    <div *ngIf="!showOutage && itemSelectionRequired != 2" id="c_create_sitem_request">
                        <!-- Incident from Service Item -->
                        <span *ngIf="canCreateServiceIncident" data-toggle="modal" data-target="#zsd_modal_new_request"
                            (click)="createServiceIncident(serviceItemDetail)"><img
                                src="img/incidentPlus.png">&nbsp;</span>
                        <!-- Service Request from Service Item -->
                        <span *ngIf="canCreateServiceRequests" data-toggle="modal" data-target="#zsd_modal_new_request"
                            (click)="createServiceRequest(serviceItemDetail)"><img
                                src="img/requestPlus.png">&nbsp;</span>
                        <!-- Chenage Request from Service Item-->
                        <span *ngIf="canCreateChangeRequests" data-toggle="modal" data-target="#zsd_modal_new_request"
                            (click)="createChangeRequest(serviceItemDetail)"><img src="img/changePlus.png">&nbsp;</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Service Item Description-->
    <!-- Moving description out of the header row so more space will be avialable -->
    <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div id="c_sitem_description_input" class="mt-3"
                [innerHTML]="_DomSanitizer.bypassSecurityTrustHtml(serviceItemDetail.description)"></div>
        </div>
    </div>

    <div class="row mt-3 ml-1">
        <div class="col-md-4 col-lg-2 col-xl-2 col-sm-4 col-4 c-sitem-detail-labels">
            {{ 'ServiceItemDetail.category' | translate }}</div>
        <div class="col-md-8 col-lg-4 col-xl-4 col-sm-8 col-8">{{serviceItemDetail.categoryName}}</div>
        <div class="col-md-4 col-lg-2 col-xl-2 col-sm-4 col-4 c-sitem-detail-labels">
            {{ 'ServiceItemDetail.itemType' | translate }}</div>
        <div class="col-md-8 col-lg-4 col-xl-4 col-sm-8 col-8">{{serviceItemDetail.itemBasicInfo?.itemTypeName}}</div>
    </div>

    <div class="row mt-3 ml-1">
        <div class="col-md-4 col-lg-2 col-xl-2 col-sm-4 col-4 c-sitem-detail-labels">
            {{ 'ServiceItemDetail.status' | translate }}</div>
        <div class="col-md-8 col-lg-4 col-xl-4 col-sm-8 col-8">{{serviceItemDetail.itemBasicInfo?.itemStatus}}</div>
        <div class="col-md-4 col-lg-2 col-xl-2 col-sm-4 col-4 c-sitem-detail-labels">
            {{ 'ServiceItemDetail.serviceLevel' | translate }}</div>
        <div class="col-md-8 col-lg-4 col-xl-4 col-sm-8 col-8">{{serviceItemDetail.itemBasicInfo?.serviceLevel}}</div>
    </div>

    <!-- For Custtom Fields -->
    <div class="row d-none d-lg-block d-xl-block" *ngFor="let row of serviceItemDetail.customFields; let i =index">
        <div class="col-6 row mt-3 ml-1" id="custom_field_display" *ngFor="let customField of matrix[i]">
            <div class="col-lg-4 col-xl-4 c-sitem-detail-labels">{{customField.displayName}}:</div>
            <div class="col-lg-7 col-xl-7 ml-1">{{customField.value}}</div>
        </div>
    </div>

    <!-- For Custtom Fields in Tablet & Mobile -->
    <div class="row mt-3 ml-1 d-lg-none d-xl-none" *ngFor="let customField of serviceItemDetail.customFields">
        <div class="col-sm-4 col-4 c-sitem-detail-labels">{{customField.displayName}}:</div>
        <div class="col-sm-8 col-8">{{customField.value}}</div>
    </div>

    <div *ngIf="canViewServiceTargets" [hidden]="!serviceItemDetail.serviceTargets">
        <div class="row mt-3 ml-1 c-sitem-targets">
            <div class="col-lg-2 col-md-2 col-xl-2 c-sitem-detail-labels">
                {{'ServiceItemsTargets.slaTargets'| translate}}
            </div>
            <div *ngIf="commonServiceLevel" class="col-lg-3 col-md-3 col-xl-3">
                {{'ServiceItemsTargets.common' | translate}}
            </div>
            <div *ngIf="!commonServiceLevel" class="col-lg-3 col-md-3 col-xl-3">
                <select class="form-control custom-select" (change)="refreshTableContent()"
                    [(ngModel)]="selectedTarget">
                    <option *ngFor="let process of serviceLevelPerProcess">
                        {{ process}}
                    </option>
                </select>
            </div>

        </div>
        <div class="row c-sitem-targets table-responsive col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
            <table class="table table-hover" id="c_starget_table">
                <thead>
                    <tr scope="col" id="c_starget_table_header">
                        <th scope="col" > {{'ServiceItemsTargets.priority'| translate}}</th>
                        <th scope="col" class="zsd_sitem_servicetargets_table_text">
                            {{'ServiceItemsTargets.responseTime'| translate}}</th>
                        <th scope="col" class="zsd_sitem_servicetargets_table_text">
                            {{'ServiceItemsTargets.restorationTime'| translate}}</th>
                        <th scope="col" class="zsd_sitem_servicetargets_table_text"> {{'ServiceItemsTargets.fixTime'| translate}}
                        </th>
                        <th scope="col" class="zsd_sitem_servicetargets_table_text">
                            {{'ServiceItemsTargets.roundClockString'| translate}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let serviceTarget of currentSlaTarget">
                        <td> {{serviceTarget.priority}}</td>
                        <td class="zsd_sitem_servicetargets_table_text"> {{serviceTarget.responseTime}}</td>
                        <td class="zsd_sitem_servicetargets_table_text"> {{serviceTarget.restorationTime}}</td>
                        <td class="zsd_sitem_servicetargets_table_text"> {{serviceTarget.fixTime}}</td>
                        <td class="zsd_sitem_servicetargets_table_text"> {{serviceTarget.roundClockString}}</td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>

    <div class="row" id="c_sitem_cancel_button">
        <div class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
            <div class="float-right">
                <button type="button" (click)=cancel() class="btn zsd_button"
                    id="zsd_cust_button_cancel">{{ 'CommonStrings.cancelButton' | translate}}</button>
            </div>
        </div>
    </div>
</div>

<div *ngIf='customCategory && itemId' class="modal" id="zsd_modal_new_request" data-backdrop="static"
    data-keyboard="false">
    <div class="modal-content">
        <div class="modal-header">
            <div> <img src={{imagePath}}/> <span id="popupHeaderString"> {{ popupHeaderString | translate }} </span></div>
            <button type="button" class="close" data-dismiss="modal" (click)=resetCreateRequest()><em class="fas fa-times"></em></button>
        </div>
        <div class="modal-body" id="override_modal_body">
            <zsd-reportincident [customCategory]=customCategory [itemId]=itemId (clearForm)=resetCreateRequest()>
            </zsd-reportincident>
        </div>
    </div>
</div>